/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWeatherQuota
 */
export interface OutputWeatherQuota {
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherQuota
     */
    dailyLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherQuota
     */
    dailyUsed?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherQuota
     */
    forecastDays?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherQuota
     */
    hourlyLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherQuota
     */
    hourlyUsed?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherQuota
     */
    minuteLimit?: number;
    /**
     * PerRunWeight — скільки коштує один прогін поточної сітки; ProjectedDaily — скільки
     * вийде за добу при поточному кроні (головна цифра для оцінки запасу). Коли збір
     * вимкнено, ProjectedDaily = 0: жодного запиту до Open-Meteo не буде.
     * @type {number}
     * @memberof OutputWeatherQuota
     */
    perRunWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherQuota
     */
    projectedDaily?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherQuota
     */
    variables?: number;
}

/**
 * Check if a given object implements the OutputWeatherQuota interface.
 */
export function instanceOfOutputWeatherQuota(value: object): boolean {
    return true;
}

export function OutputWeatherQuotaFromJSON(json: any): OutputWeatherQuota {
    return OutputWeatherQuotaFromJSONTyped(json, false);
}

export function OutputWeatherQuotaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWeatherQuota {
    if (json == null) {
        return json;
    }
    return {
        
        'dailyLimit': json['dailyLimit'] == null ? undefined : json['dailyLimit'],
        'dailyUsed': json['dailyUsed'] == null ? undefined : json['dailyUsed'],
        'forecastDays': json['forecastDays'] == null ? undefined : json['forecastDays'],
        'hourlyLimit': json['hourlyLimit'] == null ? undefined : json['hourlyLimit'],
        'hourlyUsed': json['hourlyUsed'] == null ? undefined : json['hourlyUsed'],
        'minuteLimit': json['minuteLimit'] == null ? undefined : json['minuteLimit'],
        'perRunWeight': json['perRunWeight'] == null ? undefined : json['perRunWeight'],
        'projectedDaily': json['projectedDaily'] == null ? undefined : json['projectedDaily'],
        'variables': json['variables'] == null ? undefined : json['variables'],
    };
}

export function OutputWeatherQuotaToJSON(value?: OutputWeatherQuota | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dailyLimit': value['dailyLimit'],
        'dailyUsed': value['dailyUsed'],
        'forecastDays': value['forecastDays'],
        'hourlyLimit': value['hourlyLimit'],
        'hourlyUsed': value['hourlyUsed'],
        'minuteLimit': value['minuteLimit'],
        'perRunWeight': value['perRunWeight'],
        'projectedDaily': value['projectedDaily'],
        'variables': value['variables'],
    };
}

